import { render } from "./MyClassRoom.vue?vue&type=template&id=7b9b496a&scoped=true"
import script from "./MyClassRoom.vue?vue&type=script&lang=js"
export * from "./MyClassRoom.vue?vue&type=script&lang=js"

import "./MyClassRoom.vue?vue&type=style&index=0&id=7b9b496a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9b496a"]])

export default __exports__